import { styled } from 'styled-components';
import colors from 'theme/colors';

const AboutSection = styled.section`
  background-color: ${colors.onBlack};
`;

export default AboutSection;
